export default __webpack_public_path__ + "static/media/ai-center-dark.53feb201.svg";